import React from "react";
import { string, number } from "prop-types";

/* Close icon atom component for popup close button */
const CloseIcon = ({ color = "#242424", size = 12, strokeWidth = 2 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1 1L11 11M11 1L1 11"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

CloseIcon.propTypes = {
  color: string,
  size: number,
  strokeWidth: number
};

export default CloseIcon;

